import * as moment from "moment";
import { EncodeTimeZone } from "motw_core/Services/TimeServices";
import * as React from "react";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IDiversityDateDTO } from "../../../../../../../motw_core/DTOs/IDiversityDateDTO";
import Data from "../../../../services/Data";
import MotwLogicServer from "../../../../services/External/LogicServer/MotwLogicServer";
import Nameof from "../../../../services/NameOf";

export interface IDiversityState {
    data: IDiversityDateDTO;
    goalNamesLoggedToday: string[];
}

class Diversity extends React.PureComponent<
    { diversityTarget: number },
    IDiversityState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: {
                diversityValue: 0,
                diversityTargetValue: 0,
                diversityPercent: 0,
            },
            goalNamesLoggedToday: [],
        };
    }

    async componentDidMount() {
        const diversityDate = EncodeTimeZone(moment().format());

        Data.Load.Component({
            component: this,
            load: () => MotwLogicServer.GetDiversity(diversityDate),
            stateTarget: Nameof<IDiversityState>("data"),
            inLoadAll: true,
        });

        State.ShareClass(ESharedComponent.Diversity, this);
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.Diversity, this);
    }

    componentWillUnmount() {
        Data.Unload(this);
    }

    render() {
        return null;
    }
}

export default Diversity;
